angular
    .module('userNotifications.v1')
    .directive('totalNotificationCount', totalNotificationCount);

/**
 * @ngdoc directive
 * @name userNotifications.v1.directive:totalNotificationCount
 * @restrict A
 * @element any
 *
 * @description
 * Displays the total count of all notifications that have been implemented by the theme.
 *
 * #### Script file
 * - `/web3/build/storefront/widgets/total-notification-count.v1.directive.js`
 *
 * #### Classes
 * - `isPending` : applied while notifications are in the proces of loading
 * - `isEmpty` : applied when the total notification count is 0
 *
 * #### Events
 * - `window.events.NOTIFICATION_COUNT_UPDATED` : raised whenever the notification count changes
 *
 * @example
    <pre>
        <!-- load widget script -->
        <script src="/web3/build/storefront/widgets/total-notification-count.v1.directive.js"></script>

        <!-- display widget count -->
        <span total-notification-count></span>

        <!-- respond to events -->
        <script>
            window.events.listen(window.events.NOTIFICATION_COUNT_UPDATED, function () {
                console.log('total notification count updated');
            });
        </script>
    </pre>
    */

totalNotificationCount.$inject = [];

function totalNotificationCount () {
    return {
        restrict: 'A',
        template: '<span ng-bind="totalNotificationCountController.count"></span>',
        link: function totalNotificationCount_linkFn (scope, element, attrs, controller, transclude) {},
        controller: TotalNotificationCountController,
        controllerAs: 'totalNotificationCountController',
        bindToController: true,
        scope: {}
    };
};

TotalNotificationCountController.$inject = ['$scope', '$element', 'userNotificationsService', 'authService', '$timeout'];

function TotalNotificationCountController ($scope, $element, userNotificationsService, authService, $timeout) {
    var vm = this;

    vm.count = 0;

    init();

    return;

    function init () {
        $element
            .addClass('isEmpty')
            .addClass('isPending');
        // Subscribe to auth changes
        authService.subscribe($scope, handleAuthChange);
        // Subscribe to totalNotificationCount updates
        userNotificationsService.totalNotificationCount.subscribe($scope, handleTotalNotificationCountUpdate);
        // Subscribe to classic events
        userNotificationsService.classicEvents.subscribe($scope, getTotalNotificationCount);
        // Initial loading of totalNotificationCount
        getTotalNotificationCount()
    }

    function handleAuthChange ($event, user) {
        if (!authService.isLoggedIn()) {
            return resetDirective();
        }

        getTotalNotificationCount();
    }

    function getTotalNotificationCount () {
        if (!authService.isLoggedIn()) {
            return resetDirective();
        }

        userNotificationsService.totalNotificationCount.get();
    }

    function handleTotalNotificationCountUpdate ($event, count) {
        if (count > 0) {
            $element.removeClass('isEmpty');
        } else {
            $element.addClass('isEmpty');
        }

        $timeout(function(){
            vm.count = count;
        });
        $element
            .show()
            .removeClass('isPending');
    }

    function resetDirective () {
        vm.count = 0;
        $element
            .hide()
            .addClass('isEmpty')
            .removeClass('isPending');
    }
};